// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2NPhg","footer":"ChangeClinic_footer__ALBbs"};